module.exports = __webpack_public_path__ + "static/holon-655349701998bcf8f574a051d6d696af.png";